<ng-progress></ng-progress>
<div #splashScreen class="m-splash-screen">
  <div class="page-loading">
    <div class="wrap-loader">
      <div class="item">
        <img src="../assets/images/ajax-loader.gif">
      </div>
    </div>
  </div>
</div>
<router-outlet></router-outlet> 